'use client';

import { useTranslations } from 'next-intl';
import { GlowInlineToast, ToastType } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { InnerHTML } from '../../innerHTML';

type OfferToastBannerConnectionProps = {
    title: string;
    promoCode?: string;
};

export const OfferToastBannerConnection: Component<OfferToastBannerConnectionProps> = ({ title, promoCode }) => {
    const t = useTranslations('Header.connection.banner.label');
    const promoCodeString = t('promoCode', { promoCode });

    const getOfferHtml = () => {
        if (promoCode) {
            return `${title}<br/>${promoCodeString}`;
        }
        return title;
    };

    const offerHTML = <InnerHTML rawHtml={{ content: getOfferHtml() }} />;
    return <GlowInlineToast label={{ innerHTML: offerHTML }} className={'max-w-[20rem]'} toastType={ToastType.Info} />;
};
